import React, { useEffect } from 'react';
import './SelfStoryDrawer.css';

export default function SelfStoryDrawer({
  open,
  onClose,
  onView,
  onCreate,
  canView = true,
}) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  // Lock background scroll while open
  useEffect(() => {
    if (!open) return;
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, [open]);

  if (!open) return null;

  return (
    <div className="selfstory-backdrop" onClick={onClose}>
      <div className="selfstory-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="selfstory-handle" />

        <div className="selfstory-actions">
          {canView ? (
            <button className="selfstory-btn" onClick={onView}>
              View story
            </button>
          ) : (
            <button className="selfstory-btn disabled" disabled>
              No active story to view
            </button>
          )}

          <button className="selfstory-btn" onClick={onCreate}>
            Create new story
          </button>
        </div>
      </div>
    </div>
  );
}
